/*
 * Smoothproducts version 2.0.2
 * http://kthornbloom.com/smoothproducts.php
 *
 * Copyright 2013, Kevin Thornbloom
 * Free to use and abuse under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 */

(function($) {
	$.fn.extend({
		deleteSmoothProducts: function () {
			$(document.body).off('click', '.sp-lightbox');
			$(document.body).off('click', '#sp-prev');
			$(document.body).off('click', '#sp-next');
			$(document.body).off('click', '.sp-large a');
			$(document.body).off('click', '.sp-noff-touch .sp-zoom');
			$(document.body).off('click', '.sp-tb-active a');
			$(document.body).off('click', '.sp-thumbs');
		},
		smoothproducts: function() {

			// Add some markup & set some CSS

			$('.sp-loading').hide();
			$('.sp-wrap').each(function() {
				$(this).addClass('sp-touch');
				var thumbQty = $('a', this).length;

				var firstLarge,firstThumb,
					defaultImage = $('a.sp-default', this)[0]?true:false;
				$(this).append('<div class="sp-large"></div><div class="sp-thumbs sp-tb-active"></div>');
				$('a', this).each(function(index) {
					var thumb = $('img', this).attr('src'),
						large = $(this).attr('href'),
						classes = '';
					//set default image
					if((index === 0 && !defaultImage) || $(this).hasClass('sp-default')){
						classes = ' class="sp-current"';
						firstLarge = large;
						firstThumb = $('img', this)[0].src;
					}
					$(this).parents('.sp-wrap').find('.sp-thumbs').append('<a href="' + large + '" style="background-image:url(' + thumb + ')"'+classes+'></a>');
					$(this).remove();
				});
				$('.sp-large', this).append('<a href="' + firstLarge + '" class="sp-current-big"><img src="' + firstThumb + '" alt="" /></a>');
				$('.sp-wrap').css('display', 'inline-block');
				// // If more than one image
				// if (thumbQty > 1) {
				// // If only one image
				// } else {
				// 	$(this).append('<div class="sp-large"></div>');
				// 	$('a', this).appendTo($('.sp-large', this)).addClass('.sp-current-big');
				// 	$('.sp-wrap').css('display', 'inline-block');
				// }
			});


			// Prevent clicking while things are happening
			$(document.body).on('click', '.sp-thumbs', function(event) {
				event.preventDefault();
			});


			// Is this a touch screen or not?
			$(document.body).on('mouseover', function(event) {
				$('.sp-wrap').removeClass('sp-touch').addClass('sp-non-touch');
				event.preventDefault();
			});

			$(document.body).on('touchstart', function() {
				$('.sp-wrap').removeClass('sp-non-touch').addClass('sp-touch');
			});

			// Clicking a thumbnail
			$(document.body).on('click', '.sp-tb-active a', function(event) {

				event.preventDefault();
				$(this).parent().find('.sp-current').removeClass();
				$(this).addClass('sp-current');
				$(this).parents('.sp-wrap').find('.sp-thumbs').removeClass('sp-tb-active');
				$(this).parents('.sp-wrap').find('.sp-zoom').remove();

				var currentHeight = $(this).parents('.sp-wrap').find('.sp-large').height(),
					currentWidth = $(this).parents('.sp-wrap').find('.sp-large').width();
				$(this).parents('.sp-wrap').find('.sp-large').css({
					overflow: 'hidden',
					height: currentHeight + 'px',
					width: currentWidth + 'px'
				});

				$(this).addClass('sp-current').parents('.sp-wrap').find('.sp-large a').remove();

				var nextLarge = $(this).parent().find('.sp-current').attr('href'),
					nextThumb = get_url_from_background($(this).parent().find('.sp-current').css('backgroundImage'));

				$(this).parents('.sp-wrap').find('.sp-large').html('<a href="' + nextLarge + '" class="sp-current-big"><img src="' + nextThumb + '"/></a>');
				$(this).parents('.sp-wrap').find('.sp-large').hide().fadeIn(250, function() {

					var autoHeight = $(this).parents('.sp-wrap').find('.sp-large img').height();

					$(this).parents('.sp-wrap').find('.sp-large').animate({
						height: autoHeight
					}, 'fast', function() {
						$('.sp-large').css({
							height: 'auto',
							width: 'auto'
						});
					});

					$(this).parents('.sp-wrap').find('.sp-thumbs').addClass('sp-tb-active');
				});
			});

			// Zoom In non-touch
			$(document.body).on('mouseenter', '.sp-non-touch .sp-large', function(event) {
				var largeUrl = $('a', this).attr('href');
				$(this).append('<div class="sp-zoom"><img src="' + largeUrl + '"/></div>');
				$(this).find('.sp-zoom').fadeIn(250);
				event.preventDefault();
			});

			// Zoom Out non-touch
			$(document.body).on('mouseleave', '.sp-non-touch .sp-large', function(event) {
				$(this).find('.sp-zoom').fadeOut(250, function() {
					$(this).remove();
				});
				event.preventDefault();
			});

			// Open in Lightbox non-touch
			$(document.body).on('click', '.sp-non-touch .sp-zoom', function(event) {
				var currentImg = $(this).html(),
					thumbAmt = $(this).parents('.sp-wrap').find('.sp-thumbs a').length,
					currentThumb = ($(this).parents('.sp-wrap').find('.sp-thumbs .sp-current').index())+1;
				$(this).parents('.sp-wrap').addClass('sp-selected');
				$('body').append("<div class='sp-lightbox' data-currenteq='"+currentThumb+"'>" + currentImg + "</div>");

				if(thumbAmt > 1){
					$('.sp-lightbox').append("<a href='#' id='sp-prev'></a><a href='#' id='sp-next'></a>");
					if(currentThumb == 1) {
						$('#sp-prev').css('opacity','.1');
					} else if (currentThumb == thumbAmt){
						$('#sp-next').css('opacity','.1');
					}
				}
				$('.sp-lightbox').fadeIn();
				event.preventDefault();
			});

			// Open in Lightbox touch
			$(document.body).on('click', '.sp-large a', function(event) {
				var currentImg = $(this).attr('href'),
					thumbAmt = $(this).parents('.sp-wrap').find('.sp-thumbs a').length,
					currentThumb = ($(this).parents('.sp-wrap').find('.sp-thumbs .sp-current').index())+1;

				$(this).parents('.sp-wrap').addClass('sp-selected');
				$('body').append('<div class="sp-lightbox" data-currenteq="'+currentThumb+'"><img src="' + currentImg + '"/></div>');

				if(thumbAmt > 1){
					$('.sp-lightbox').append("<a href='#' id='sp-prev'></a><a href='#' id='sp-next'></a>");
					if(currentThumb == 1) {
						$('#sp-prev').css('opacity','.1');
					} else if (currentThumb == thumbAmt){
						$('#sp-next').css('opacity','.1');
					}
				}
				$('.sp-lightbox').fadeIn();
				event.preventDefault();
			});

			// Pagination Forward
			$(document.body).on('click', '#sp-next', function(event) {
				event.stopPropagation();
				var currentEq = $('.sp-lightbox').data('currenteq'),
					totalItems = $('.sp-selected .sp-thumbs a').length;

					if(currentEq >= totalItems) {
					} else {
						var nextEq = currentEq + 1,
						newImg = $('.sp-selected .sp-thumbs').find('a:eq('+currentEq+')').attr('href'),
						newThumb = get_url_from_background($('.sp-selected .sp-thumbs').find('a:eq('+currentEq+')').css('backgroundImage'));
						if (currentEq == (totalItems - 1)) {
							$('#sp-next').css('opacity','.1');
						}
						$('#sp-prev').css('opacity','1');
						$('.sp-selected .sp-current').removeClass();
						$('.sp-selected .sp-thumbs a:eq('+currentEq+')').addClass('sp-current');
						$('.sp-selected .sp-large').empty().append('<a href='+newImg+'><img src="'+newThumb+'"/></a>');
						$('.sp-lightbox img').fadeOut(250, function() {
							$(this).remove();
							$('.sp-lightbox').data('currenteq',nextEq).append('<img src="'+newImg+'"/>');
							$('.sp-lightbox img').hide().fadeIn(250);
						});
					}

				event.preventDefault();
			});

		// Pagination Backward
			$(document.body).on('click', '#sp-prev', function(event) {

				event.stopPropagation();
				var currentEq = $('.sp-lightbox').data('currenteq'),
					currentEq = currentEq - 1;
					if(currentEq <= 0) {
					} else {
						if (currentEq == 1) {
							$('#sp-prev').css('opacity','.1');
						}
						var nextEq = currentEq - 1,
						newImg = $('.sp-selected .sp-thumbs').find('a:eq('+nextEq+')').attr('href'),
						newThumb = get_url_from_background($('.sp-selected .sp-thumbs').find('a:eq('+nextEq+')').css('backgroundImage'));
						$('#sp-next').css('opacity','1');
						$('.sp-selected .sp-current').removeClass();
						$('.sp-selected .sp-thumbs a:eq('+nextEq+')').addClass('sp-current');
						$('.sp-selected .sp-large').empty().append('<a href='+newImg+'><img src="'+newThumb+'"/></a>');
						$('.sp-lightbox img').fadeOut(250, function() {
							$(this).remove();
							$('.sp-lightbox').data('currenteq',currentEq).append('<img src="'+newImg+'"/>');
							$('.sp-lightbox img').hide().fadeIn(250);
						});
					}
				event.preventDefault();
			});


			// Close Lightbox
			$(document.body).on('click', '.sp-lightbox', function() {
				closeModal();
			});

			// Close on Esc
			$(document).keydown(function(e) {
				if (e.keyCode == 27) {
					closeModal();
					return false;
				}
			});

			function closeModal (){
				$('.sp-selected').removeClass('sp-selected');
				$('.sp-lightbox').fadeOut(function() {
						$(this).remove();
				});
			}


			// Panning zoomed image (non-touch)

			$('.sp-large').mousemove(function(e) {
				var viewWidth = $(this).width(),
					viewHeight = $(this).height(),
					viewOffset = $(this).offset(),
					largeWidth = $(this).find('.sp-zoom').width(),
					largeHeight = $(this).find('.sp-zoom').height(),
					relativeXPosition = (e.pageX - viewOffset.left),
					relativeYPosition = (e.pageY - viewOffset.top),
					moveX = Math.floor((relativeXPosition * (viewWidth - largeWidth) / viewWidth)),
					moveY = Math.floor((relativeYPosition * (viewHeight - largeHeight) / viewHeight));

				$(this).find('.sp-zoom').css({
					left: moveX,
					top: moveY
				});

			});

			function get_url_from_background(bg){
				return bg.match(/url\([\"\']{0,1}(.+)[\"\']{0,1}\)+/i)[1];
			}
		}
	});
})(jQuery);


$(function() {

	Shopify.handleize = function (str) {
		str = str.toLowerCase();
	
		var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
		
		// For the old browsers
		for (var i = 0; i < toReplace.length; ++i) {
			str = str.replace(toReplace[i], "");
		}
	
		str = str.replace(/\W+/g, "-");
	
		if (str.charAt(str.length - 1) == "-") {
			str = str.replace(/-+\z/, "");
		}
	
		if (str.charAt(0) == "-") {
			str = str.replace(/\A-+/, "");
		}
	
		return str
	};

	$(document).ready(function() {
		$('.site-navigation').removeClass('not-ready');
		$('body').attr('data-page-ready', 'true');
	});

	// Date Time Picker
	$('.form-field-datetime').datetimepicker({
		closeOnWithoutClick: false,
		closeOnTimeSelect: true,
		minDate: 0,
		allowTimes:[
			'09:00',
			'09:30',
			'10:00',
			'10:30',
			'11:00', 
			'11:30',
			'12:00',
			'12:30',
			'13:00',
			'13:30',
			'14:00', 
			'14:30',
			'15:00', 
			'15:30',
			'16:00', 
		],
		onGenerate: function(current_time, $input){
			$(this).find('.xdsoft_date.xdsoft_day_of_week0').addClass('xdsoft_disabled');
		},
		onShow: function(current_time, $input) {
			console.log(window.prevent_calendar);
			if (window.prevent_calendar) {
				$(this).addClass('__stay');
			}
		},
		onClose: function(current_time, $input) {
			// var _this = this;
			// console.log(window.prevent_calendar);

			if ($input.val() !== '') {
				$input.addClass('form-field-filled');
			}

			// if (window.prevent_calendar) {
			// 	window.prevent_calendar = false;
			// 	$(this).addClass('__stay');

			// 	setTimeout(function() {
			// 		$(_this).removeClass('__stay').css({
			// 			'display': 'block'
			// 		});
			// 	}, 100);
			// } else {
			// 	$(this).removeClass('__stay');
			// }
		},
		onSelectTime: function(current_time, $input) {
			if ($(this).hasClass('__stay')) {
				$(this).removeClass('__stay');
			}
		}
	});

	$(document).on('click', '.xdsoft_datetimepicker, [cart-updating]', function(event) {
		event.stopPropagation();
	});

	$(document).on('click', function(event) {

		if (window.prevent_calendar) {
			$('.xdsoft_datetimepicker').each(function() {
				// console.log('test:', !window.prevent_calendar && this.style.display == 'block');
				if($(this).hasClass('__stay')) {
					$(this).removeClass('__stay');
					console.log('lol');
				}
				
				if (this.style.display == 'block') {
					$(this).hide();
					this.style.display == 'none';
					window.prevent_calendar = false;
				}
			});
		}
	});

	$('#workshop_date_time_pickup, #workshop_date_time_preferred').focus(function() {
		CustomEvents.showPopUp('Please note: the final date & time will need to be<br/>confirmed by our workshop manager');
	});

	// Product Zoom 
	$('.sp-wrap').smoothproducts();

	// Check if google.maps is loaded
	if (typeof google == 'object' && typeof google.maps == 'object') {

		var autocomplete;

		// Auto Initialize
		(function initAutocomplete() {

			var addressFields = document.getElementsByClassName('form-field-address');

			for (var i = 0; i < addressFields.length; i++) {
				autocomplete = new google.maps.places.Autocomplete(addressFields[i], {
					types: ['geocode'],
					componentRestrictions: {
						country: ['NZ']
					}
				});
			}
		})();

	}

	// Accordion Collections
	$('.productgrid--sidebar-menu .navmenu-link--active')
		.closest('.navmenu-submenu')
		.siblings('.navmenu-link-parent')
		.addClass('navmenu-link--active');

	// Variant
	(function() {
		// Somewhat like constructor
		var $this = new function() {

			this.container = $('.productitem--variants');
			this.el = $('.productitem--variants-container');
			this.variantItem = $('.productitem--variants-item');
			this.scrollWidth = this.variantItem.outerWidth();
			this.move = {
				left: this.container.find('.move-left'),
				right: this.container.find('.move-right')
			}

			this.checkStatePosition = function(el) {
				var container = el != 'undefined' ? el : this.el;
				var button = {
					left: el != 'undefined' ? el.parent().find('.move-left') : this.move.left,
					right: el != 'undefined' ? el.parent().find('.move-right') : this.move.right
				}

				var scrollContainer = container.parent().find('.productitem--variants-container');
				var totalChildren = scrollContainer[0].children.length;
				var itemTotalwidth = totalChildren * this.scrollWidth;

				setTimeout(function(){
					if (scrollContainer.scrollLeft() <= 0) {
						button.left.hide();
					} else {
						button.left.show();
					}

					if (Math.ceil(scrollContainer.scrollLeft() + scrollContainer.outerWidth()) >= itemTotalwidth) {
						button.right.hide();
					} else {
						button.right.show();
					}
				}, 250);
			}

			this.scroll = function(el, action) {
				var scrollAmount = 0;
				var container = el.parent().find('.productitem--variants-container');
				switch (action) {
					case 'right':
						scrollAmount = container.scrollLeft() + this.scrollWidth;
						break;
					case 'left':
						scrollAmount = container.scrollLeft() - this.scrollWidth;
						break;
					default:
						console.log('ERROR: this.scroll()');
						break;
				}
				container.animate({
					scrollLeft: scrollAmount
				}, 250);

				$this.checkStatePosition(el);
			}

			this.changeImage = function(variant) {
				var productLink = variant.parents('.productitem--image-block').find('.productitem--image-link');
				productLink.attr('href', variant.find('a').attr('href'));
				if (variant.find('img').length > 0) {
					var imgScr = variant.find('img').attr('src')
					// 50x50 is defined in swatch.liqud, see line: 55
					// '_' underscore is automatically added
					imgSrc = imgScr.replace('_50x50', '');

					var img = new Image();
					productLink.addClass('loading');
					img.onload = function() {
						productLink.find('.productitem--image').find('img').attr({
							src: img.src,
							srcset: img.src + ' 1.00x' // '1.00x' is embeded in srcset attr by default
						});
						productLink.removeClass('loading');
					}
				    img.src = imgSrc;
				}
			}

		};


		$this.el.each(function(index, el) {
			$this.checkStatePosition($(this));
		});
		$this.move.left.click(function(event) { $this.scroll($(this), 'left') });
		$this.move.right.click(function(event) { $this.scroll($(this), 'right') });
		$this.variantItem.mouseover(function() {
		    $this.changeImage($(this));
		});

	})();

	$('.product-tab-menu__item a').on('click', function(e) {
		e.preventDefault();
		$('.product-tab-menu__item, .product-tab-content__item').removeClass('active');
		$(this).parent().addClass('active');
		var $target =$($(this).attr('href'));
		$target.addClass('active');
	});

	$(document).on('click', '.productgrid--sidebar-menu .navmenu-link--active', function(event) {
		if ($(this).siblings('.navmenu').length > 0) {
			event.preventDefault();
			$(this).addClass('navmenu-link--prevent-loading').removeClass('navmenu-link--active');
		}
	});

	$(document).on('click', '.productgrid--sidebar-menu .navmenu-link--prevent-loading', function(event) {
		event.preventDefault();

		$(this).removeClass('navmenu-link--prevent-loading').addClass('navmenu-link--active');
	});


	$('#form-option-colour .option-value .option-value-name').click(function() {
		setTimeout(function() {
			var $link = $('.product-gallery--navigation .sp-large > a')
			$link.removeClass('prevent-zoom');
			
			var $image = $link.find('img')[0];

			if ($image.naturalHeight < 600 || $image.naturalWidth < 600) {
				$link.addClass('prevent-zoom');
			}
		}, 150);
	});

	var $linkLists = $('.site-navigation .navmenu-depth-2 .navmenu');

  // view all option if the menu is too long
	$linkLists.each(function() {
		var $linkItem = $(this).siblings('.navmenu-link-parent');
		var $linkSubItems = $(this).children();
		var itemCount = $linkSubItems.length;
		
		if (itemCount > 8) { // Total Items you want to cut 
			$linkSubItems.each(function(i) {
				if (i > 5) { // 9 = 10, (always addtional 1)
					$(this).remove();
				}
			});

			$(this).append('<li class="navmenu-item">'+
				'<a class="navmenu-link" href="'+ $linkItem.attr('href') +'" aria-expanded="true">'+
				'View all'+
				'</a>'+
			'</li>');
		}
	});

	// URL Params
	(function() {
		
		var _this = new function() {
			var _this = this;
			this.getUrlParam = function() {
				var vars = {};
				var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
					vars[key] = value;
				});
				return vars;
			}

			this.getUrlParamString = function() {
				return window.location.href.split('?')[1];
			}

			this.applyUrlParam = function (selector, attr, cb1) {
				var $el = $(selector);

				$el.each(function() {
					var link = $(this).attr(attr);
					if (_this.getUrlParamString()) {
						$(this).attr(attr, link.concat('?' + _this.getUrlParamString()));
					}
				});
			}
		};

		var url_string = window.location.href
		var url = new URL(url_string);

		if(!url.searchParams.get('page') && url.searchParams.get('sort_by')) {
			_this.applyUrlParam('.utils-sortby--brand .form-field-select option', 'value');
		}
		
		if (url_string.indexOf('/cart') === -1 && url.searchParams.get('contact_posted') == 'true') {
			CustomEvents.showPopUp('Thanks for contacting us.<br/>We will get back to you as soon as possible.');
		}

	})();

	// Add "Clearance" Tag on links in Clearance Page
	(function() {
		
		var _this = new function() {
			var _this = this;
			var currentUrl = window.location.pathname;

			this.isClearance = function() {
				return $('.clearance--section').length > 0 || currentUrl.indexOf('clearance') > -1;
			}

			this.isCollection = function() {
				return currentUrl.indexOf('collections') > -1
			}

			this.isActive = function(url, callback) {
				var tags = this.getCurrentTags();
				var itemLink = tags.substr(tags.indexOf(url), tags.length);

				return itemLink.indexOf(url) > -1 || url == itemLink
			}

			this.getCurrentTags = function() {
				var currentUrl = windowUrl.substr(urlOrigin.length, windowUrl.length);
				var urlParts = currentUrl.split('/');

				return urlParts[urlParts.length - 1];
			}

			this.applyClearanceTag = function() {

				if(_this.isClearance()) {
					$('.menu-sidebar--item--level-1 > a, .productgrid--sidebar-menu a').each(function() {

						var link = $(this).attr('href');
						var linkParts = link.split('/');
						var baseUrl = linkParts.slice(0, 3).join('/');
						var urlTags = linkParts.slice(3, linkParts.length).join('');

						if (linkParts.length > 3) {
							$(this).attr('href', baseUrl + '/clearance+' + urlTags);
						} else {
							$(this).attr('href', baseUrl + '/clearance');
						}

						// if (_this.isCollection()) {
						// 	if (_this.isActive(urlTags)) {
						// 		$(this).addClass('navmenu-link--active');
						// 	}
						// }

					});

					$('.productgrid--sidebar-title').text('Clearance');
					$('.productgrid--sidebar-menu')
				}
			}
			
		};

		_this.applyClearanceTag();

	})();

	$('.viewModel').on('click', function() {
		var pdfLink = $('#selectModel').val();
		window.open(pdfLink, '_blank');
	});

	// Select Category
	(function() {
		
		var _this = new function() {
			var _this = this;
			this.$select = $('.form-field-select');
			this.categoryOption = 'option[position="0"]';
		};
		
		_this.$select.each(function() {
			$(this).prepend($(this).find(_this.categoryOption));
		});

	})();

	// Related Products Dropdown Cart
	(function() {
		
		var _this = new function() {
			var _this = this;
			this.$button = $('.productitem--action-trigger');
		};
		
		$(document).on('click', '.atc-banner--container .productitem--action-trigger', function() {
			var $this = $(this);
			var isAtc = $this.hasClass('productitem--action-atc');
			
			var selector = $this.closest('.productitem').siblings('.productitem-quickshop').data('product-quickshop');
			var $productItem = $('.site-main .related-products--container [data-product-quickshop=' + selector + ']').siblings('.productitem');

			if (isAtc) {
				$productItem.find('.productitem--actions .productitem--action-atc').trigger('click');
			} else {
				$productItem.find('.productitem--actions [data-quickshop-full]').trigger('click');
			}
		});
	})();

	// Cart
	(function() {
		$('.contact-form').parsley();

		var isFirefox = typeof InstallTrigger !== 'undefined';

		window.Parsley.on('form:error', function() {
		// This global callback will be called for any field that fails validation.
			if (isFirefox) {
				$(window).scrollTop($(window).scrollTop() - $('.site-header-wrapper').height() -10 );
			}
		});

		if (window.location.pathname === '/cart') {
			CustomCart.cartUpdateInit();

			// if ($('#delivery-type__collect > form').length > 0) {
			// 	$('#delivery-type__collect > form').parsley().on('form:validate', function() {
			// 		if (!CustomCart.hasBike) {
			// 			window.location.href = '/checkout';
			// 		}
			// 	});
			// }

			if ($('.custom-checkout-process form').length > 0) {
				$('.custom-checkout-process form').each(function (i, el) {
					var completeItems = '';
					$(el).parsley().on('form:submit', function() {
						var form = $(el)
						$('body').append('<div cart-updating><h2>Preparing Your Order...</h2></div>');
						if (completeItems === '') {
							CustomCart.getCart(function(cart) {
								for (var item of cart.items) {
									if (item.variant_title) {
										completeItems += 'Product Name: ' + item.product_title + '('+ item.variant_title +')' + '\n' +
												'Price: ' + Shopify.formatMoney(item.price) + '\n' +
												'Qty: ' + item.quantity + '\n\n';
									} else {
										completeItems += 'Product Name: ' + item.product_title + '\n' +
												'Price: ' + Shopify.formatMoney(item.price) + '\n' +
												'Qty: ' + item.quantity + '\n\n';
									}
								}
			
								form.find('[name="contact[items]"]').val(completeItems);
								form.submit();
								$('[cart-updating]').remove();
							});
						}
						return completeItems !== '';
					});
				})
			}

			$('.listitem-delivery-type_link').on('click', function(event) {
				event.preventDefault();
				var targetId = $(this).attr('href');
				var $target = $(targetId);
				var isProceed = true;

				if (targetId.includes('ship')) {
					$('.cart-item--assembly-option').find('[id*="_yes"]').each(function(i, el) {
						if ($(el).prop('checked')) {
							isProceed = false;
						}
					});

					if (!isProceed) {
						return;
					}
				}

				$('.listitem-delivery-type, .delivery-type-content__item').removeClass('active');

				$target.addClass('active');
				$(this).parent().addClass('active');

				if ($(this).attr('href') == '#delivery-type__collect') {
					// $('.cart-checkout--proceed').show();
				} else {
					CustomCart.toggleCheckoutButton(); // Not Issue
				}
			});

			$('.cart-item--remove > a').on('click', function() {
				CustomCart.cartUpdateInit();
                  setTimeout(function() {
                    window.location.reload(true);
                  }, 1000);
			});

			$(document).on('change', '.cart-item--assembly-option .form-field-custom-option', function(event) {
				var product = $(this).data('product-id');
				var isAssembled = JSON.parse(this.value);

				
				var OffBikeSetting = {
					product: product,
					extra: $(this).data('extra-id')
				}
				
				console.log({
					OffBikeSetting,
					isAssembled
				})

				if (isAssembled && $('[href="#delivery-type__ship"]').parent().hasClass('active')) {
					$('#assembly_'+product+'_no').prop('checked', true);
					event.preventDefault();
					return;
				}

				CustomCart.getAssemblyIndex(product, function(idx) {
					if (idx > -1) {
						if (isAssembled) CustomCart.assembled.splice(idx, 1, OffBikeSetting)
						else CustomCart.assembled.splice(idx, 1)
					} else {
						CustomCart.assembled.push(OffBikeSetting);
					}

					CustomCart.cartUpdateInit();
				});
				
			});

			$(document).on('mouseenter', '.cart-item--assembly-option .form-field-checkbox[for*="_yes"]', function() {
				if ($('[href="#delivery-type__ship"]').parent().hasClass('active')) {
					showDefaultErrorToastr();
				}
			});

			$(document).on('mouseenter', '[href="#delivery-type__ship"]', function() {
				$('.cart-item--assembly-option').find('[id*="_yes"]').each(function(i, el) {
					if ($(el).prop('checked')) {
						showDefaultErrorToastr();
						return;
					}
				});
			});

			$(document).on('mouseleave', '.cart-item--assembly-option .form-field-checkbox[for*="_yes"], [href="#delivery-type__ship"]', function() {
				toastr.clear();
			});

			function showDefaultErrorToastr() {
				toastr.options = {
					"closeButton": true,
					"progressBar": false,
					"positionClass": "toast-bottom-right",
					"preventDuplicates": true,
					"showDuration": 100,
					"hideDuration": 10,
					"timeOut": "0",
					"extendedTimeOut": "0",
				}

				toastr['error']('Shipping Option is not available for Off-Road Assembled bikes.', 'Please Note!');
			}

			$(document).on('click', '.cart-item--custom-remove-link', function() {
				var $cartItem = $(this).parents('.cart-item');
				var product = $cartItem.data('cartitem-id');
				
				CustomCart.getAssemblyIndex(product, function(idx) {
					if (idx > -1) CustomCart.assembled.splice(idx, 1);

					CustomCart.cartUpdateInit();
				});
			});

			var formData = $('#contact_form').serializeArray();
			var url_string = window.location.href
			var url = new URL(url_string);
			var formCount = 0;

			for (var field of formData) {
				if (url.searchParams.get(field.name)) {
                  console.log(field.name);
					formCount += 1;
				}
			}
			
			if ((formData.length > 0 && formCount >= formData.length - 1) || url.searchParams.get('contact_posted') == 'true') {
				CustomCart.clearCart(function(cart) {
					window.history.replaceState({}, document.title, '/cart');
					$('#shopify-section-static-cart').html(CustomCart.orderSuccess());
				});
			}

		}

		$('.default-checkout-process a[href="/checkout"]').on('click', function(event) {
			event.preventDefault();
		})
        
        

		window.checkoutOnAtcBanner = function (formInstance, cart) {
			$('body').append('<div cart-updating><h2>Updating Cart...</h2></div>');
			CustomCart.checkCart(function(hasBike) {
				if (hasBike) {
					window.location.href = '/cart';
				} else {
					window.InjectFBLCN(formInstance, cart);
				}
				$('[cart-updating]').remove();
			});
		}

		window.InjectFBLCN = function (formInstance, cart) {
			var fields = formInstance.fields;
           
			for (var i = 0; i < fields.length; i++) {
				var field = fields[i];
        
				if (field.element.name === 'note') {
                   field.element.value=''
					var lineItems = ((cart || {}).items || []);
					if (lineItems.length > 0) {
						field.element.value += '\n';
						lineItems.forEach(function(item) {
							var info = item.product_description;
							if (info) {
								var indexOfLocation = info.toLowerCase().lastIndexOf('fblcn');
								if (indexOfLocation > -1) {
									console.log('This have location:', item)
									field.element.value += '\n' + item.product_title + '\n' + info.substr(indexOfLocation).trim();
								} else {
									field.element.value += '\n' + item.product_title + '\n' + 'FBLCN: N/A';
								}
							}
						});
					}
				}
			}

			if (formInstance.element.classList.contains('checkout-form--atc-banner')) {
				formInstance.element.classList.add('fblcn-injected');
				formInstance.element.submit();
			}
		}

		var checkoutForms = $('[action="/checkout"]').parsley();
		if (checkoutForms && checkoutForms.length > 0) {
			checkoutForms.forEach(function(form) { 
				form.on('form:submit', function (formInstance) {
					window.InjectFBLCN(formInstance, CustomCart.cart);
					$('body').append('<div cart-updating><h2>Updating Cart...</h2></div>');
					return true;
				});	
			});
		}
	})();

	// Custom Product
	(function(_this, _cart) {
		_this.Product(function(product) {
			$('.sp-large > a').addClass('product-gallery-preview');

			_this.ProductContentInit($('.site-main .product--content'), product);


			var settings = _cart.settings();

			for (var productType in settings) {
				if (settings.hasOwnProperty(productType)) {
					if (productType === product.type) {
						_this.AddAssemblyCostNote(product.type);
					}
				}
			}

			_this.SetActiveSideMenuItem($('.productgrid--sidebar-menu > .navmenu-depth-1').find('.navmenu-link--active'), product);

			$('[href="#tab-sizing-chart"]').parent().hide();
			if (product.type.toLowerCase().indexOf('protection') > -1 || product.type.toLowerCase().indexOf('apparel') > -1) {
				$('[href="#tab-sizing-chart"]').parent().attr('style', '');
			}
		});

		if ($('#shopify-section-static-collection').length > 0) {
			$('.productgrid--utils.utils-sortby').each(function() {
				$(this).find('.utils-sortby-select').SetSelectecWidth();
			});
		}

		// Default Preview Image Zoom Settings
		if ($('.product-gallery--navigation .sp-large').length > 0) {
			var defaultImg = $('.product-gallery--navigation .sp-large').find('img')[0];
			if (defaultImg.naturalHeight < 600 || defaultImg.naturalWidth < 600) {
				$('.product-gallery--navigation .sp-large > a').addClass('prevent-zoom');
			}
		}

		$('.site-main [data-related-products] [data-product-row]').slick({
			infinite: false,
			slidesToShow: 5,
			slidesToScroll: 5,
			dots: false
		});


		$(document).on('click', '.product-form--atc-button', function() {			
			_this.addedVariantImage = $('#form-option-colour .option-value-input:checked + .option-value-name').attr('data-src');
		});

	})(CustomProduct, CustomCart);

	// Custom Collection
	(function(_this) {
		_this.GetAllProductData(function(products) {

			function GetOptionImages(productImages, optionName) {
				var optionImages = new Array;

				if (productImages.length > 0) {
					for (var imgSrc of productImages) {
						if (imgSrc.toLowerCase().indexOf(optionName.toLowerCase()) > -1) {
							optionImages.push(imgSrc);
						}
					}
				}

				if (optionImages.length > 0) {
					for (const imgSrc of optionImages) {
						var imgIndex = productImages.indexOf(imgSrc);
						if (imgIndex > -1) {
							productImages.splice(imgIndex, 1);
						}	
					}
				}
				
				return optionImages;
			}

			$('.productitem').each(function(i) {
				var product = products[i];
				var $productVariants = $(this).find('.productitem--variants-container');
				var $variantItems = $productVariants.children();
				
				var options = new Array;
				$.each($variantItems, function(index, variant) {
					var optionValue = $(variant).attr('data-value');
					if (optionValue.split('/').length > 1 || optionValue.split(/\s/g).length > 1) {
						options.unshift(optionValue);
					} else {
						options.push(optionValue);
					}
				});
				
				product.color_options = new Object;
				$.each($variantItems, function() {
					if (options.length > 0) {
						for (var option of options) {
							var optionName = option.replace(/\s/g, '_').split('/').join('_');
							if (product.images) {
								if (product.images.length > 0) {

									var swatches = GetOptionImages(product.images, optionName);

									if (swatches) {
										product.color_options[option] = swatches;
									}
								}
							}
						}
						var singleOption = Object.keys(product.color_options)[0];
						if (Object.keys(product.color_options).length === 1 && product.color_options[singleOption].length === 0)  {
							if (options.length === 1) {
								product.color_options[singleOption] = product.images;
							}
						}
					}
				});
				
				$.each($variantItems, function(index, variant) {
					_this.UpdateSwatches(product, $(variant));
				});

			});
		});
		if (window.location.href.indexOf('/collections/') > -1) {
			_this.GetAvailableFilterOption(function(options) {
				_this.RemoveOtherOptions(options);
				// console.log('removing...', options);
			});

			if ($('[data-section-type="static-brand-collection"]').length > 0) {
				var brandScript = $('[data-section-type="static-brand-collection"]').text().trim();
				var brandScriptData = JSON.parse(brandScript).data;

				console.log(brandScriptData);
				
				var brandId = '#brand-' + brandScriptData.id;
				var $brandContent = $(brandScriptData.content);


				console.log(brandId, $brandContent);
				$('.collection--information').append($brandContent.find(brandId).html());
			}

			if ($('[data-section-id="current-tags"]').length > 0) {
				var currentTags = JSON.parse($('[data-section-id="current-tags"]').text().trim()).tags;

				var currentTag = Shopify.handleize(currentTags[0]);
				var $submenu = $('.productgrid--sidebar .navmenu-depth-2').find('.navmenu-link-parent.navmenu-link--active').siblings('.navmenu-submenu');

				$submenu.find('.navmenu-id-' + currentTag).find('.navmenu-link').addClass('navmenu-link--active');
			}

			$('.utils-sortby:not(.utils-sortby--default) .form-field-select').change(function() {
				$(this).parent().SetSelectecWidth();
			});

			if ($('.productgrid--no-results').length > 0) {
				var $activeTopMenu = $('.productgrid--sidebar .navmenu-depth-1 > .navmenu-item-parent > .navmenu-link--active');
				$('.productgrid--no-results-button').attr('href', $activeTopMenu.attr('href'));
				$('.productgrid--no-results-button').text('VIEW ALL ' + $activeTopMenu.text().trim() + ' PRODUCTS');
			}
		}
	})(CustomCollection);


	(function() {
		if ($(window).width() < 860) {
			$(document).on('click', '.mobile-nav-content .navmenu .navmenu-link-parent', function(event) {
				event.preventDefault();
				$(this).toggleClass('navmenu-link--active');
			});
		}
	})();
});


// Custom Events
var CustomEvents = {
	showPopUp: function(message) {
		window.prevent_calendar = true;
		$('body').append(
			'<div cart-updating class="contact">' +
				'<div class="popup-container">' +
					'<h2>' + message + '</h2>' +
					'<span class="popup-close"><i class="fas fa-times"></i></span>' +
					'<span class="popup-timer" style="width: 100%;"></span>' +
				'</div>' +
			'</div>'
		);

		var timeOut = 10000;
		var timeInterval = 1000;
		var totalWidth = 100;
		var timeDeduction = timeOut / timeInterval; // 1000

		var popupTimeout = setTimeout(function(){
			$('[cart-updating]').remove();
		}, timeOut);

		var popupProgress = setInterval(function(){
			// totalWidth = ((timeOut - timeDeduction) / timeOut) * 100;
			totalWidth = totalWidth - timeDeduction;
			$('.popup-timer').css({
				width: totalWidth + '%'
			});

			if (totalWidth <= 0) {
				clearPopup()
			}
		}, timeInterval);

		$(document).on('click', '.popup-close', function() {
			clearPopup();
		});

		function clearPopup() {
			clearTimeout(popupTimeout);
			clearInterval(popupProgress);
			$('[cart-updating]').remove();
		}
	}
}

// Custom Cart
var CustomCart = {
	settings: function() {
      //Assembly Rules
      // product Type: product Handle/Name
      //var settings = 'Body Panels-Road-Bike Parts-SPTS:Big Item Shipping Cost (To Be Confirmed)|Plastic Kit & Graphics-Off rd-Bike Parts-APTS:Big Item Shipping Cost (To Be Confirmed)|EV-Road-Moped-che:Moped Assembly,compliance,PDI|Scooter-Road-Moped-che:Moped Assembly,compliance,PDI|Scooter-Road-Motuo-che:Motorcycle Assembly,compliance,PDI,3yr WOF|Motorcycle-Road-Motuo-che:Motorcycle Assembly,compliance,PDI,3yr WOF|ATV Youth-Off Rd-Four Wheeler-che:Small ATV & Pit Bike Assembly, 1st oil Change|ATV Farm-Off Rd-Four Wheeler-che:Big ATV & Dirt Bike Assembly, 1st oil Change|Dirt Bike-Off Rd-Two Wheeler-che:Big ATV & Dirt Bike Assembly, 1st oil Change|Pit Bike-Dirt Bike-Off Rd-Two Wheeler-che:Small ATV & Pit Bike Assembly, 1st oil Change|Big ATV-Off Rd-Four Wheeler-che:Big ATV & Dirt Bike Assembly, 1st oil Change|Electrics- Balance Bike-Off Rd-Two Wheeler-che:Electric ATV and Balance Bike Assembly|Electrics-ATV Youth-Off Rd-Four Wheeler-che:electric-atv-and-balance-bike-assembly|Road-Off Rd-Tools & Workshop - Oversized:Big Item Shipping Cost (To Be Confirmed)|Engines-Off Rd-Bike Parts-APTS:Big Item Shipping Cost (To Be Confirmed)|Engines-Off Rd-Bike Parts-DPTS:Big Item Shipping Cost (To Be Confirmed)|Engines-Road-Bike Parts-SPTS:Big Item Shipping Cost (To Be Confirmed)|Tyres-Off Rd-Bike Parts-Oversized:Shipping Cost + Tyre Stewardship Fee (To Be Confirmed)|Tyres-Off Rd-Bike Parts-APTS:Shipping Cost + Tyre Stewardship Fee (To Be Confirmed)|Tyres-Off Rd-Bike Parts-DPTS:Shipping Cost + Tyre Stewardship Fee (To Be Confirmed)|Tyres-Off Rd-Bike Parts-PPTS:Shipping Cost + Tyre Stewardship Fee (To Be Confirmed)|Tyres-Road-Bike Parts-SPTS:Shipping Cost + Tyre Stewardship Fee (To Be Confirmed)| Wheels-Off Rd-Bike Parts-Oversized:Shipping Cost + Tyre Stewardship Fee (To Be Confirmed)'.split('|');
    var settings = 'Body Panels-Road-Bike Parts-SPTS:Big Item Shipping Cost (To Be Confirmed)|Plastic Kit & Graphics-Off rd-Bike Parts-APTS:Big Item Shipping Cost (To Be Confirmed)|EV-Road-Moped-che:Moped Assembly,compliance,PDI|Scooter-Road-Moped-che:Moped Assembly,compliance,PDI|Scooter-Road-Motuo-che:Motorcycle Assembly,compliance,PDI,3yr WOF|Motorcycle-Road-Motuo-che:Motorcycle Assembly,compliance,PDI,3yr WOF|ATV Youth-Off Rd-Four Wheeler-che:Small ATV & Pit Bike Assembly, 1st oil Change|ATV Farm-Off Rd-Four Wheeler-che:Big ATV & Dirt Bike Assembly, 1st oil Change|Dirt Bike-Off Rd-Two Wheeler-che:Big ATV & Dirt Bike Assembly, 1st oil Change|Pit Bike-Dirt Bike-Off Rd-Two Wheeler-che:Small ATV & Pit Bike Assembly, 1st oil Change|Big ATV-Off Rd-Four Wheeler-che:Big ATV & Dirt Bike Assembly, 1st oil Change|Electrics- Balance Bike-Off Rd-Two Wheeler-che:Electric ATV and Balance Bike Assembly|Electrics-ATV Youth-Off Rd-Four Wheeler-che:electric-atv-and-balance-bike-assembly|Road-Off Rd-Tools & Workshop - Oversized:Big Item Shipping Cost (To Be Confirmed)|Engines-Off Rd-Bike Parts-APTS:Big Item Shipping Cost (To Be Confirmed)|Engines-Off Rd-Bike Parts-DPTS:Big Item Shipping Cost (To Be Confirmed)|Engines-Road-Bike Parts-SPTS:Big Item Shipping Cost (To Be Confirmed)|Wheels-Off Rd-Bike Parts-Oversized:shipping-cost-and-tyre-stewardship-fee-to-be-confirmed|Tyres-Off Rd-Bike Parts-PPTS:Shipping Cost and Tyre Stewardship Fee (To Be Confirmed)|Tyres-Off Rd-Bike Parts-APTS:Shipping Cost and Tyre Stewardship Fee (To Be Confirmed)|Tyres-Road-Bike Parts-SPTS:Shipping Cost and Tyre Stewardship Fee (To Be Confirmed)|Tyres-Off Rd-Bike Parts-Oversized:Shipping Cost and Tyre Stewardship Fee (To Be Confirmed)'.split('|'); 
	
  	  var rules = {};
      
      //var dealer = window.ShopifyAnalytics.meta.page.customerId;
      //if(dealer == 6530832236770){
        //console.log(window.ShopifyAnalytics.meta.page.customerId == 6530832236770);
      //}
		for (var setting of settings) {
			var item = setting.split(':');
            //console.log(item);
			if (!rules[item[0]]) {
				rules[item[0]] = item[1].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
		}
      //console.log(rules);
		return rules;
	},
	orderSuccess: function() {
		return '<header class="cart-title"><h1>Thank you for placing your order we will promptly get back to you with a confirmation via email.</h1></header>'+
		'<a href="/collections/all" class="slideshow-button button-primary">Continue Shopping</a>';
	},
	assembled: [],
	getAssemblyIndex: function (product, callback) {
		var idx = this.assembled.findIndex(function(o) {
			return o.product === product;
		})
		if (callback) callback(idx);
	},
	extraCharge: '[data-cartitem-extra-id]',
	getRules: function(callback) {
		var $_this = this;
		var settings = $_this.settings();

		var productsToGet = []

		for (var productType in settings) {
			if (settings.hasOwnProperty(productType)) {
				if (productsToGet.indexOf(settings[productType]) === -1) {
					productsToGet.push(settings[productType]);
				}
			}
		}

		var products = [];
		(function getProduct(i) {
			if (i < productsToGet.length) {
				$.ajax({
					type: 'GET',
					url: '/products/'+ productsToGet[i] +'.js',
					dataType: 'json'
				}).done(function(response) {
					products.push(response);
					getProduct(i + 1);
				});
			} else {
				callback(products, settings);
			}
		})(0);

		
	},
	getProduct: function(handle, callback) {
		$.get('/products/'+ handle +'.js').done(function(response) {
			var product = JSON.parse(response)
			callback(product);
		});
	},
	addCartItem: function(items, callback) {
		var $_this = this;
		Shopify.queue = [];

		for (var id in items) {
			if (items.hasOwnProperty(id)) {
				Shopify.queue.push({
					id: id,
					qty: parseInt(items[id])
				});
			}
		}

		Shopify.moveAlong = function() {
			if (Shopify.queue.length) {
				var request = Shopify.queue.shift();
				$.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: {
						id: request.id,
						quantity: request.qty
					},
					dataType: 'json'
				}).done(function() {
					Shopify.moveAlong();
				});
			}
			else {
				$_this.getCart(function(cart) {
					$_this.cart = cart;
					callback($_this.cart);
				});	
			}
		};

		Shopify.moveAlong();
	},
	ShopifyCart: function(action, items, callback) {
		var $_this = this;
		switch (action) {
			case 'add':
				$_this.addCartItem(items, function(cart) {
					callback(cart);
				});
				break;
			case 'edit':
				$.ajax({
					type: 'POST',
					url: '/cart/update.js',
					data: {
						updates: items
					},
					dataType: 'json'
				}).done(function(response) {
					callback(response);
				});
				break;
			default:
				console.log('ERROR: Action is not valid!');
		}
	},
	getCart: function(callback) {
		var $_this = this;
		$.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json'
		}).done(function(response) {
			$_this.cart = response;
			callback($_this.cart);
		});
	},
	addAssemblyCostDOM: function(product, assembly, qty, required) {
		//console.log("ddddddd" + product, assembly, qty, required)
		var $_this = this;
		$('[data-cartitem-id="'+ assembly.id +'"]').remove();
		// console.log(product);
        //bike only so the filter is off road & wheeler (pit bike and ATV)
		var isOffRoad = product.product_type.toLowerCase().indexOf('off rd') > -1 && product.product_type.toLowerCase().indexOf('wheeler') > -1 ;
		var showToaster = isOffRoad && required;

		$('.cart-item--assembly-option').find('[id*="_yes"]').each(function(i, el) {
			if ($(el).prop('checked') && $('[href="#delivery-type__ship"]').parent().hasClass('active')) {
				$_this.show_toastr = {
					type: 'error',
					title: 'Please Note!',
					message: 'Shipping Option is not available for Off-Road Assembled bikes.'
				};
			}
		});
       
		var OffRoadAssembledOption = isOffRoad ? '<div class="cart-item--assembly-option">'+
			'<div class="cart-item--assembly-item">'+
				'<input class="form-field-custom-option" name="assembly_'+ product.id +'" type="radio" id="assembly_'+ product.id +'_yes" data-product-id="'+ product.id +'" data-extra-id="'+ assembly.id +'" value="true" checked="checked" />'+
				'<label class="form-field-checkbox" for="assembly_'+ product.id +'_yes">'+
					'Assembled'+
				'</label>'+
			'</div>'+
			'<div class="cart-item--assembly-item">'+
				'<input class="form-field-custom-option" name="assembly_'+ product.id +'" type="radio" id="assembly_'+ product.id +'_no" data-product-id="'+ product.id +'" data-extra-id="'+ assembly.id +'" value="false"  />'+
				'<label class="form-field-checkbox" for="assembly_'+ product.id +'_no">'+
					'Non-Assembled'+
				'</label>'+
			'</div>'+
		'</div>' : '';

		var TotalAssemblyCost = '<div class="cart-item--info">'+
			'<div class="cart-item--total">'+
				'<span class="money">'+ Shopify.formatMoney(assembly.price * qty) +'</span>'+
				OffRoadAssembledOption +
			'</div>'+
			'<div class="cart-item--remove"></div>'+
		'</div>';
		
		var OptionalAssemblyCost = '<div class="cart-item--info">'+
			'<div class="cart-item--total">'+
				'<p style="margin: 0;"><small>Please choose one of the following options:</small></p>'+
				'<div class="cart-item--assembly-option">'+
					'<div class="cart-item--assembly-item">'+
						'<input class="form-field-custom-option" name="assembly_'+ product.id +'" type="radio" id="assembly_'+ product.id +'_yes" data-product-id="'+ product.id +'" data-extra-id="'+ assembly.id +'" value="true" />'+
						'<label class="form-field-checkbox" for="assembly_'+ product.id +'_yes">'+
							'Assembled'+
						'</label>'+
					'</div>'+
					'<div class="cart-item--assembly-item">'+
						'<input class="form-field-custom-option" name="assembly_'+ product.id +'" type="radio" id="assembly_'+ product.id +'_no" data-product-id="'+ product.id +'" data-extra-id="'+ assembly.id +'" value="false" checked="checked" />'+
						'<label class="form-field-checkbox" for="assembly_'+ product.id +'_no">'+
							'Non-Assembled'+
						'</label>'+
					'</div>'+
				'</div>'+
			'</div>'+
			'<div class="cart-item--remove"></div>'+
		'</div>';

		var cartInfo = required ? TotalAssemblyCost : OptionalAssemblyCost;
		//console.log(product, assembly); 
        //console.log(cartInfo);

		return '<div class="cart-item--inner cart-item--extra-charge">'+
			'<div class="cart-item--content">'+
				'<h2 class="cart-item--content-title">+ '+ assembly.name +'</h2>'+
				'<div class="cart-item--content-price">' +
					'<span class="cart-item--price-title">Price </span>' +
					'<span class="money">'+ Shopify.formatMoney(assembly.price) +'</span>' +
				'</div>'+
			'</div>'+
		
			cartInfo +
		'</div>'
	},
	itemsToRemove: function(cart) {
		var itemsToRemove = {}
		var assemblyItems = cart.items.filter(function(item) {
			if (item.product_type === 'assembly-cost') {
				itemsToRemove[item.id] = 0
				return item;
			}
		});

		if (assemblyItems.length > 0) {
			return itemsToRemove;
		}
		return null
	},
	addAssemblyCost: function(cart, callback) {
		var $_this = this;
		var itemsToAdd = {}

		$_this.getRules(function(rules, settings) {
			var OffBikeItems = cart.items.filter(function(item) {
				// console.log('item:', item);
				var assembledProduct;
				for (var setting of $_this.assembled) {
					if (setting.product === item.id) {
						assembledProduct = setting;
					}
				}
				for (var productType in settings) {
					if (settings.hasOwnProperty(productType)) {
						if (productType === item.product_type) {

							for (var assembly of rules) {
								if (settings[productType] === assembly.handle) {
									var rule = assembly.variants[0];
									var $cartItem = $('[data-cartitem-id='+ item.id +']');

									if ($cartItem.find('.cart-item--extra-charge').length === 0) {
                                      //bike only so the filter is off road & wheeler (pit bike and ATV)
										if (item.product_type.toLowerCase().indexOf('off rd') > -1 && item.product_type.toLowerCase().indexOf('wheeler') > -1) {
											if (assembledProduct) {
												itemsToAdd[assembledProduct.extra] = itemsToAdd[assembledProduct.extra]
													? itemsToAdd[assembledProduct.extra] + item.quantity : item.quantity;
													$cartItem.append($_this.addAssemblyCostDOM(item, rule, item.quantity, true));
											} else {
												$cartItem.append($_this.addAssemblyCostDOM(item, rule, item.quantity, assembledProduct ? true : false));	
											}
											return item;
										}
				
										itemsToAdd[rule.id] = itemsToAdd[rule.id] ? itemsToAdd[rule.id] + item.quantity : item.quantity;
										$cartItem.append($_this.addAssemblyCostDOM(item, rule, item.quantity, true));
									}
								}
							}
						}	
					}
					
				}
			});

			 //if (OffBikeItems.length > 0) {
		 	//$('.cart-checkout').hide(); 
			 //}
            if (OffBikeItems.length > 0) {
		 	$('.cart-checkout--proceed').hide(); 
			 }

			callback(itemsToAdd, OffBikeItems);
		});
	},
	clearCart: function(callback) {
		$.ajax({
			type: 'POST',
			url: '/cart/clear.js',
			dataType: 'json'
		}).done(function(response) {
			$('.site-header-cart--count').removeClass('visible');
			callback(response);
		});
	},
	cartUpdate: function(cart, callback) {
		var $_this = this;
		var itemsToRemove = $_this.itemsToRemove(cart);
		$('.cart-item--extra-charge').remove();
		//console.log({itemsToRemove})
		if (itemsToRemove) {
			// console.log('triggered: remove');
			$_this.ShopifyCart('edit', itemsToRemove, function(cart) {
				// console.log('REMOVE:', cart);
				$_this.cartUpdate(cart, callback);
			})
		} else {
			// console.log('triggered: add');
			$_this.addAssemblyCost(cart, function(itemsToAdd, OffBikeItems) {
				//console.log({itemsToAdd, OffBikeItems})
				if ($.isEmptyObject(itemsToAdd) && OffBikeItems.length <= 0) {
					$_this.hasBike = false;
					$_this.toggleCheckoutButton('link');
					$('.cart-checkout').show();
					return returnCallback(cart);
				} else {
					if ($.isEmptyObject(itemsToAdd)) return returnCallback(cart)
					//console.log('ADDING:', {itemsToAdd})
					$_this.hasBike = true;
					$_this.ShopifyCart('add', itemsToAdd, function(cart) {
						//console.log({cart})
						returnCallback(cart);
					});
				}
			});
		}

		function returnCallback(cart) {
			// console.log('ADD:', cart);
			if (callback) {
				callback(cart);
			}
		}
	},
	changesExtraChange: function($cartItem) {
		var $_this = this;
		var $select = $cartItem.find('select[data-cartitem-quantity]');
		var currentQty = $cartItem.attr('data-cartitem-qty')
		var newQty = $select.val();
		
		$cartItem.attr('data-cartitem-qty', newQty);

		if (currentQty !== newQty) {
			$_this.cartUpdateInit();
		}
		
	},
	cartUpdateInit: function() {
		var $_this = this;
		$_this.show_toastr = false;
		toastr.options = {
			"closeButton": true,
			"progressBar": true,
			"positionClass": "toast-bottom-right",
			"preventDuplicates": true,
			"showDuration": "500",
			"hideDuration": "100",
			"timeOut": "10000",
			"extendedTimeOut": "10000",
		}
		$('body').append('<div cart-updating><h2>Updating Cart...</h2></div>');
      // not showing the checkout button
		$_this.getCart(function(cart) {
			//console.log(cart)
          
			if (cart.item_count > 0) {
				// console.log('init');
				$_this.cartUpdate(cart, function(cart) {
					$('[data-cart-total]').text(Shopify.formatMoney(cart.total_price));
					$('[cart-updating]').remove();
				// if has body panel;
                 /* for(var i=0; i < cart.item_count;i++ ){
                  	var checkItem =cart.items[i].product_type;
                    if(checkItem == "Body Panels-Road-Bike Parts-SPTS")
                    {
						var hasBodyPanel = 0;                    
                    }
                  }*/
					if ($_this.hasBike && $('#delivery-type__collect').css('display') === 'none') {
						$_this.toggleCheckoutButton(); // Not Issue
					}

					if ($_this.show_toastr) {
						toastr[$_this.show_toastr.type]($_this.show_toastr.message, $_this.show_toastr.title);
						if ($('#delivery-type__ship').css('display') !== 'none') {
							$('[href="#delivery-type__collect"]').trigger('click');
						}
					}
				});
			} else {
				$('[cart-updating]').remove();
			}
		});
	},
	checkCart: function(callback) {
		var $_this = this;
		$_this.getCart(function(cart) {
			//console.log(cart);
			$_this.getRules(function(products, settings) {
				//console.log(settings);
				for (var item of cart.items) {
					for (var productType in settings) {
						if (settings.hasOwnProperty(productType)) {
							if (productType === item.product_type) {
								return callback(true);
							}
						}
					}
				}
				return callback(false);
			});
		});
	},
	toggleCheckoutButton: function (action) {
		if (action === 'link') {
			$('.custom-checkout-process').hide();
			$('.cart-checkout--proceed').addClass('link-only');
			return;
		}
		$('.cart-checkout--proceed').removeClass('link-only').hide();
	}
}

var CustomProduct = {
	//sizeFormat: ['0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', 'YXXS','Y2XS','YXS','YS','YM','YL','YXL','YXXL','Y2XL','3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL','2XL', 'XXXL','3XL','4XL','5XL','6XL','8XL', 'YS 47-48cm','YS 49-50cm','YS 48-49cm','YM 49-50cm','YM 50-51cm','YM 51-52cm','YL 51-52cm','YL 52-53cm','YL 53-54cm', 'YXL 53-54cm','YXL 54-55cm','YXL 55-56cm', '3XS 49-50cm', 'XXS 51-52cm','2XS 51-52cm', 'XS 53-54cm', 'S 55-56cm', 'M 57-58cm', 'MS 57cm', 'ML 58cm','L 58-59cm','L 59-60cm', 'XL 60-61cm','XL 61-62cm', 'XXL 62-63cm','XXL 63-64cm','2XL 63-64cm', '3XL 65-66cm', '4XL 67-68cm', '5XL 69-70cm', 'XXS 51cm','2XS 51cm', 'XS 53cm','XS 54cm', 'S 55cm', 'M 57cm','L 59cm', 'XL 60cm', 'XXL 61cm','2XL 61cm', '3XL 62cm','S/M','M/L','L/XL','XL/XXL','XXL/3XL', 'US1 / EU33', 'US2 / EU34', 'US3 / EU35', 'US4 / EU36', 'US5 / EU37', 'US6 / EU38', 'US7 / EU39', 'US8 / EU41', 'US9 / EU42', 'US10 / EU43', 'US11 / EU45', 'US12 / EU46', 'US13 / EU47', 'US14 / EU48', 'US15 / EU49', 'US16 / EU51', 'Waist 6', 'Waist 8', 'Waist 10', 'Waist 12', 'Waist 14', 'Waist 16', 'Waist 18', 'Waist 20', 'Waist 22', 'Waist 23', 'Waist 24','Waist 25','Waist 26', 'Waist 27','Waist 28', 'Waist 30', 'Waist 32', 'Waist 34', 'Waist 36', 'Waist 38', 'Waist 40', 'Waist 42', 'Waist 44', 'Waist 46', 'Waist 48', 'Waist 50', 'Stout 1: XL-3XL', 'Stout 2: 4XL-6XL', 'Stout 3: 7XL-8XL'],
	sizeFormat: ['0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', 'YXXS','Y2XS','YXS','YS','YM','YL','YXL','YXXL','Y2XL','3XS', 'XXS', 'XS','S', 'S/M', 'M','M/L','L','L/XL','XL', 'XL/XXL','XXL','2XL', 'XXXL','3XL','4XL','5XL','6XL','8XL', 'YS 47-48cm','YS 49-50cm','YS 48-49cm','YM 49-50cm','YM 50-51cm','YM 51-52cm','YL 51-52cm','YL 52-53cm','YL 53-54cm', 'YXL 53-54cm','YXL 54-55cm','YXL 55-56cm', '3XS 49-50cm', 'XXS 51-52cm','2XS 51-52cm', 'XS 53-54cm', 'S 55-56cm','S 56cm','M 57-58cm', 'MS 57cm', 'ML 58cm','L 58-59cm','L 59-60cm', 'XL 60-61cm','XL 61-62cm', 'XXL 62-63cm','XXL 63-64cm','2XL 63-64cm', '3XL 65-66cm', '4XL 67-68cm', '5XL 69-70cm', 'XXS 51cm','2XS 51cm', 'XS 53cm','XS 54cm', 'S 55cm','MS 58cm','M 57cm','M 58cm','ML 60cm','L 59cm','L 60cm','L 61cm', 'XL 60cm','XL 61cm','XL 62cm', 'XXL 61cm','XXL 62cm','XXL 64cm','2XL 61cm', '3XL 62cm','XXL/3XL', 'US1 / EU33', 'US2 / EU34', 'US3 / EU35', 'US3 / EU35.5', 'US4 / EU36','US4 / EU37', 'US5 / EU37','US5 / EU38', 'US6 / EU38', 'US6 / EU39','US6.5 / EU38.5','US7 / EU39','US7 / EU40.5','US7.5 / EU40', 'US8 / EU40.5','US8 / EU41', 'US8 / EU42','US8.5 / EU41','US9 / EU42','US9 / EU42.5','US9 / EU43','US9.5 / EU42.5','US9.5 / EU43', 'US10 / EU43','US10 / EU44','US10 / EU44.5', 'US10.5 / EU43.5','US10.5 / EU44','US10.5 / EU44.5', 'US11 / EU44','US11 / EU45','US11 / EU45.5', 'US11.5 / EU45','US11.5 / EU46','US12 / EU45.5','US12 / EU46','US12 / EU46.5','US12 / EU47','US12.5 / EU45.5','US12.5 / EU46','US13 / EU47','US13 / EU48','US13.5 / EU47.5','US14 / EU48','US14 / EU49','US14 / EU49.5', 'US15 / EU49','US15 / EU51', 'US16 / EU51', 'US16 / EU52','Waist 6', 'Waist 8', 'Waist 10', 'Waist 12', 'Waist 14', 'Waist 16', 'Waist 18', 'Waist 20', 'Waist 22', 'Waist 23', 'Waist 24','Waist 25','Waist 26', 'Waist 27','Waist 28', 'Waist 30', 'Waist 32', 'Waist 34', 'Waist 36', 'Waist 38', 'Waist 40', 'Waist 42', 'Waist 44', 'Waist 46', 'Waist 48', 'Waist 50', 'Stout 1: XL-3XL', 'Stout 2: 4XL-6XL', 'Stout 3: 7XL-8XL'],
	
  
    Product: function(callback) {
		var _this = this;
		if ($('#shopify-section-static-product').length >= 1) {
			var data = $('[data-section-data][data-section-id="static-product"]').text().trim();
			var product = JSON.parse(data).product;
			// _this.variants = product.variants;
			_this.images = product.images;

			if (product.options) {
				_this.options = _this.GetOptions(product.options);
			}

			callback(product);
		}
	},
	GetOptions: function(_options) {
		var options = new Object;
		if (_options.length > 0) {
			for (var option of _options) {
				if (option === 'Colour' || option === 'Color') {
					options[option] = new Object;
				} else {
					options[option] = new Array;
				}
				
			}
		}

		return options;
	},
	ProductContentInit: function($productContainer, product) {
		var _this = this;
		_this.SetupProductThumbnails($productContainer.find('.form-options'), product, function() {
			_this.SetPreviewThumbnails($productContainer);
		});
		_this.SortSizes($productContainer);
		_this.BindMouseEvents($productContainer);
	},
	SetupProductThumbnails: function($productContent, product, callback) {
		var _this = this;
		var productOptions = _this.GetOptions(product.options);
		_this.options = productOptions;

		function GetOptionImages(productImages, optionName, optionImages) {
			if (productImages.length > 0) {
				for (var imgSrc of productImages) {
					if (imgSrc.toLowerCase().indexOf(optionName.toLowerCase()) > -1) {
						optionImages.push(imgSrc);
					}
				}
			}

			if (optionImages.length > 0) {
				for (const imgSrc of optionImages) {
					var imgIndex = productImages.indexOf(imgSrc);
					if (imgIndex > -1) {
						productImages.splice(imgIndex, 1);
					}	
				}
			}
			return optionImages;
		}

		$productContent.each(function() {
			$optionName = $(this).find('.option-name').text().trim();
			if (productOptions.hasOwnProperty($optionName)) {
				var options = [];
				var ops = [];

				$(this).find('.option-values .option-value').each(function() {
					var optionValue = $(this).find('.option-value-input').val();
					if ($optionName === 'Colour' || $optionName === 'Color') {
						ops.push(optionValue.split('/'))
						if (optionValue.split('/').length > 1 || optionValue.split(/\s/g).length > 1) {
							options.unshift(optionValue);
						} else {
							options.push(optionValue);
						}
					} else {
						productOptions[$optionName].push(optionValue);
					}
				});

				options = options.sort(function(a, b){
					return b.length - a.length;
				});
				//console.log(options)
				if ($optionName === 'Colour' || $optionName === 'Color') {
					if (options.length > 0) {

						var productImages = $.extend(true, [], product.images);
						for (var option of options) {
							var optionName = option.replace(/\s/g, '_').split('/').join('_');
							var optionNameWOspace = option.replace(/\s/g, '').split('/').join('');
							var optionImages = new Array;

							var images = GetOptionImages(productImages, optionName, optionImages);
							var imagesWOspace = GetOptionImages(productImages, optionNameWOspace, new Array());

							//console.log('heey', {
							//	imagesWOspace: imagesWOspace,
								//images: images
							//})
							if (images.length > 0 || imagesWOspace.length > 0) {
								var imgs = images.length > 0 ? images : imagesWOspace;
								productOptions[$optionName][option] = imgs;
							}
						}
						if (Object.keys(productOptions[$optionName]).length === 0)  {
							if (options.length === 1) {
								productOptions[$optionName][options[0]] = productImages;
							}
						}

					}

					$(this).find('.option-values .option-value').each(function() {
						_this.ApplyThumbnail($(this), productOptions, product);
					});
				}
			}
		});

		callback();
	},
	SetPreviewThumbnails: function($productContainer, $activeColor) {
		var _this = this;
		if ($activeColor) {
			var $currentColour = $activeColor;
		} else {
			var $currentColour = $productContainer.find('#form-option-colour .option-value-input:checked + .option-value-name');
		}
		var currentImage = $currentColour.attr('data-src');
		// <a href="//cdn.shopify.com/s/files/1/2423/6717/products/Black_1_bd7d3278-8c6f-4a10-86e4-684562b0cf49_947x1024.jpg?v=1538523147" style="background-image:url(//cdn.shopify.com/s/files/1/2423/6717/products/Black_1_bd7d3278-8c6f-4a10-86e4-684562b0cf49_947x1024.jpg?v=1538523147)" class="sp-current"></a>
		$('.sp-thumbs').html('');

		// console.log({
		// 	currentImage: currentImage,
		// 	currentColour: $currentColour
		// })

		
		if (_this.options.hasOwnProperty('Colour')) {
			//console.log(_this.options)
			for (var color in _this.options['Colour']) {
				if (_this.options['Colour'].hasOwnProperty(color)) {
					if ($currentColour.text().trim() === color) {
						// console.log('Current Color:', color)
						var colorImages = _this.options['Colour'][color];
						for (var image of colorImages) {
							// console.log(image === currentImage, colorImages)
							if (image === currentImage) {
								$('.sp-thumbs').append('<a href="'+ image +'" style="background-image:url('+ image +')" class="sp-current"></a>');
							} else {
								$('.sp-thumbs').append('<a href="'+ image +'" style="background-image:url('+ image +')"></a>');
							}
						}
					}
				}
			}
		}
	},
	SortSizes: function($productContainer) {
		var _this = this;
		var renderedSizes = new Array;

		// Getting the redered size by shopify
		$productContainer.find('#form-option-size .option-value').each(function() {
			var size = $(this).find('.option-value-input').val();
			$(this).attr('data-rendered-size-order', size);
			renderedSizes.push(size);
		});

		// Reaarrange the size from shopify to formatted size below
		var sortedSizesDom = new Array;
		if (renderedSizes.length > 0) {
			for (var formatSize of _this.sizeFormat) {
				for (var renderedSize of renderedSizes) {
					if (renderedSize == formatSize) {
						var sizeDom = $productContainer.find('#form-option-size .option-value[data-rendered-size-order="' + renderedSize + '"]')[0];
						sortedSizesDom.push(sizeDom);
					}
				}
			}
		}

		// Apply sorted sizes
		if (sortedSizesDom.length > 0) {
			$productContainer.find('#form-option-size .option-values').html('');
			
			for (var sortedDom of sortedSizesDom) {
				$productContainer.find('#form-option-size .option-values').append(sortedDom);
			}
		}
	},
	BindMouseEvents: function($productContainer) {
		var _this = this;
		var $optionTitle = $productContainer.find('#form-option-colour .option-header .option-name');
		var $currentColour = $productContainer.find('#form-option-colour .option-selected .option-value-name');

		$optionTitle.html('Colour: <span class="current-colour">'+ $currentColour.text() +'</span>');
		$optionTitle.find('.current-colour').attr('data-selected-colour', $currentColour.text());

		$productContainer.find('.product-gallery-preview').attr({
			'href': $currentColour.attr('data-src'),
			'data-selected-image': $currentColour.attr('data-src')
		});
		

		$productContainer.find('.product-gallery-preview').find('img').attr('src', $currentColour.attr('data-src'));

		$productContainer.find('#form-option-colour .option-value-name--image').mouseover(function() {
			var $preview = $productContainer.find('.product-gallery-preview');
			var image = $(this).data('src');
			var colour = $(this).text();

			$preview.attr('href', image);
			$preview.find('img').attr('src', image);
			$optionTitle.find('.current-colour').text(colour);
		}).mouseleave(function() {
			var $preview = $productContainer.find('.product-gallery-preview');
			var colour = $optionTitle.find('.current-colour').attr('data-selected-colour');
			$optionTitle.find('.current-colour').text(colour);

			$preview.attr('href', $preview.attr('data-selected-image'));
			$preview.find('img').attr('src', $preview.attr('data-selected-image'));
		});

		$($productContainer).on('click', '#form-option-colour .option-value-name', function() {
			var $preview = $productContainer.find('.product-gallery-preview');
			var image = $(this).data('src');
			var colour = $(this).text();

			$optionTitle.find('.current-colour').text(colour);

			$preview.attr({
				'href': image,
				'data-selected-image': image
			});
			$preview.find('img').attr('src', image);
			$optionTitle.find('.current-colour').attr('data-selected-colour', colour);

			_this.SetPreviewThumbnails($productContainer, $(this));
		});

		$($productContainer).on('touchstart', '#form-option-colour .option-value-label', function(event) {
			$(this).find('.option-value-name').trigger('click');
		});

		$(document).on('click', '.sp-lightbox a', function(event) {
			event.stopPropagation();
		});

		$(document).on('click', '.sp-thumbs a', function(event) {
			$('.sp-large > a').addClass('product-gallery-preview').attr('data-selected-image', $(this).attr('href'));
			var $image = $('.sp-large > a img')[0];

			if ($image.naturalHeight < 600 || $image.naturalWidth < 600) {
				$('.sp-large > a').addClass('prevent-zoom');
			}
		});

		$(document).on('click', '.sp-lightbox', function(event) {
			_this.SetPreviewThumbnails($productContainer);
			$('.sp-large > a').addClass('product-gallery-preview').attr('data-selected-image', $('.sp-thumbs a.sp-current').attr('href'));
			$('.sp-large > a img').attr('src', $('.sp-thumbs a.sp-current').attr('href'));
		});
	},
	ApplyThumbnail: function($option, options, product) {
		// console.log(product)
		var _this = this;
		var _input = $option.find('.option-value-input')[0];
		var $thumbnail = $option.find('.option-value-name');

		// if (product.variants) {
		// 	for (var variant of product.variants) {
		// 		if (variant.featured_image && variant.options) {
		// 			for (var option of variant.options) {
		// 				if (option === _input.value) {
		// 					$thumbnail.addClass('option-value-name--image');
		// 					$thumbnail.attr('data-src', variant.featured_image.src);
		// 					$thumbnail.css({
		// 						'background-image': 'url(' + variant.featured_image.src + ')'
		// 					});
		// 				}
		// 			}
		// 		}
		// 	}
		// }

		if (options.Colour.hasOwnProperty(_input.value)) {
			$thumbnail.addClass('option-value-name--image');
			$thumbnail.attr('data-src', options.Colour[_input.value][0]);
			$thumbnail.css({
				'background-image': 'url(' + options.Colour[_input.value][0] + ')'
			});
			// console.log($option, options.Colour[_input.value])
		}
	},
	AddAssemblyCostNote: function(type) {
		var _this = this;
		CustomCart.getRules(function(products, settings) {
			for (var productType in settings) {
				if (settings.hasOwnProperty(productType)) {
					if (productType === type) {

						for (var product of products) {
							if (settings[productType] === product.handle) {

								$(_this.AssemblyNoteDom(product, type)).insertAfter($('[data-product-details]'));
								
							}
						}
					}
				}
			}			
		});
	},
	AssemblyNoteDom: function (product, type) {
		//var isOffRoadBike = type.toLowerCase().indexOf('road') > -1 ? false : true;
		//var isRoadBike = type.toLowerCase().indexOf('off rd') > -1 ? false : true;
      // ##########Panels and off road wheel showing on road cast and Assembly cost, now only bikes showing. use type include "road" and "off rd"##########
        var isOffRoadBike = type.toLowerCase().includes('off rd' )&& type.toLowerCase().includes('che') ? true : false;
		var isRoadBike = type.toLowerCase().includes('road' )&& type.toLowerCase().includes('che') ? true : false;

		if (isOffRoadBike) {
			var assembly_cost = {
				label: "Assembly Cost",
				message: "Assembly Cost is approx. " + Shopify.formatMoney(product.price) + ", Includes Assembly and PDI"
			}
		}
		if (isRoadBike) {
			var assembly_cost = {
				label: "On Road Cost",
				  //message: "On Road Cost (O.R.C) is approx. " + Shopify.formatMoney(product.price) + ", Includes Assembly, PDI. Excluding 1st 6 Months Registration"
                    message: "On Road Cost (O.R.C) includes Assembly, PDI and 6 OR 12 Months Registration"
			}
		}

		return '<div class="product-assembly-cost">'+
			'<div class="product-assembly-cost_left">'+
				'<div class="tooltip-trigger">'+
					'<span class="tooltip-trigger__label">'+
						assembly_cost.label +
						'<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"> <path d="M16,1.3C7.9,1.3,1.3,7.8,1.3,16c0,8.2,6.6,14.8,14.7,14.8c8.1,0,14.7-6.6,14.7-14.8C30.7,7.8,24.1,1.3,16,1.3z M17.1,24.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.3c0-0.5,0.2-0.9,0.5-1.2 c0.3-0.3,0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2C17.6,23.5,17.4,23.9,17.1,24.2z M21.3,13.6 c-0.3,0.5-0.6,0.9-0.9,1.3c-0.4,0.4-1,1-1.9,1.8c-0.3,0.2-0.5,0.4-0.6,0.6c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.1-0.1,0.3-0.2,0.4 c0,0.1-0.1,0.4-0.2,0.8c-0.1,0.8-0.6,1.2-1.4,1.2c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1.2c0-0.6,0.1-1.2,0.3-1.7 c0.2-0.5,0.5-0.9,0.8-1.2c0.3-0.4,0.8-0.8,1.3-1.3c0.5-0.4,0.8-0.7,1.1-1c0.2-0.2,0.4-0.5,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.9 c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-1-0.6-1.8-0.6c-0.8,0-1.5,0.2-1.9,0.6c-0.4,0.4-0.7,1-1,1.9c-0.3,0.9-0.8,1.3-1.5,1.3 c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.4-0.6-0.4-1c0-0.7,0.2-1.5,0.7-2.2c0.5-0.7,1.1-1.4,2-1.8c0.9-0.5,1.9-0.7,3.1-0.7 c1.1,0,2.1,0.2,2.9,0.6c0.8,0.4,1.5,1,2,1.7c0.5,0.7,0.7,1.5,0.7,2.3C21.7,12.6,21.6,13.1,21.3,13.6z"/> </svg>'+
					'</span>'+
					'<div class="tooltip">'+
						'<span class="arrow"></span>'+
						assembly_cost.message +
					'</div>'+
				'</div>'+
			'</div>'+
			'<div class="product-assembly-cost_right">'+
				'<span>Excluded</span>'+
			'</div>'+
		'</div>';	
	},
	SetActiveSideMenuItem: function($menuItem, product) {
		var _this = this
		var $listItems = $menuItem.siblings('.navmenu').children();

		for (var listItem of $listItems) {
			var $listItem = $(listItem);
			var $link = $listItem.children('.navmenu-link');
			
			for (var tag of product.tags) {
				if ($link.text().trim() === tag) {
					$link.addClass('navmenu-link--active');
					if ($listItems.children('.navmenu-submenu').length > 1) {
						_this.SetActiveSideMenuItem($link, product);
					}
					// return;
				}
			}
		}
	},
	ModalThumbnail: function(_modal) {
		console.log(_modal);
		var _this = this;
		var $modalContent = _modal.modal.$modalInner;
		var _product = _modal.product

		$modalContent.find('[data-product-gallery]')
			.find('.product-galley--image-background')
			.addClass('product-gallery-preview');
		
		// .html(
		// 	'<figure class="product-gallery--image image--selected is-selected">' +
        // 		'<div class="product-gallery--image-background ">' +
 		// 			'<img src="https://dummyimage.com/480x480/fff/fff.jpg&text=" />' +
		// 		'</div>' +
		// 	'</figure>'
		// );

		_this.ProductContentInit($modalContent, _product);
	}
}

var CustomCollection = {
	GetAllProductData: function(callback) {
		var products = new Array;
		$('[data-product-quickshop-data]').each(function() {
			products.push(JSON.parse($(this).html()).product);
		});

		callback(products);
	},
	UpdateSwatches: function(product, $thumbnail) {
		var color = $thumbnail.attr('data-value');
		
		if (product.color_options.hasOwnProperty(color)) {
			// $thumbnail.find('a').append('<span class="variant--background" style="background-image: url(' + product.color_options[color] + ')"></span>');
		}
	},
	GetAvailableFilterOption: function(callback) {
		var _this = this;
		// https://www.forza.nz/collections/road-bike-parts/products.json
		var host = window.location.origin;
		
		if ($('[data-api-get]').length > 0) {
			var $selectsContainer = $('.utils-sortby:not(.utils-sortby--default)');
			$.each($selectsContainer, function(i, select) {
				$(select).addClass('utils-sortby--loading');
			});

			var collectionUrl = $('[data-api-get]').attr('data-api-get');
			var endpoint = host + collectionUrl

			$.ajax({
				type: 'GET',
				url: endpoint + '.json',
				dataType: 'json'
			}).done(function(response) {
				var collection = response.collection;
				var limit = 250;
				var apiCallCount = Math.ceil(collection.products_count / limit);
				var API_QUEUE = new Array;

				var availableOptions = new Array;

				for (var i = 0; i < apiCallCount; i++){
					API_QUEUE.push(endpoint + '/products.json?limit=' + limit + '&page=' + (i + 1));
				}

				var GetProducts = function() {
					if (API_QUEUE.length > 0) {
						var request = API_QUEUE.shift();
						$.ajax({
							type: 'GET',
							url: request,
							dataType: 'json'
						}).done(function(response) {
							_this.CheckForAvailableTag(availableOptions, response.products, function() {
								GetProducts();
							});
						});
					}
					else {
						callback(availableOptions);
					}
				};
		
				GetProducts();
			});
		}
	},
	CheckForAvailableTag: function(availableOptions, products, callback) {
		var $selects = $('.utils-sortby:not(.utils-sortby--default) .form-field-select');
		var $activeTags = $('.productgrid--sidebar .navmenu-depth-3 .navmenu-link.navmenu-link--active');

		// console.log(products);

		var isClearance = function() {
			return $('.clearance--section').length > 0 || window.location.pathname.indexOf('clearance') > -1;
		}

		$.each($selects, function(i, select) {
			var options = $(select).children();
			for (var option of options) {
				// console.log(option.text)
				if (option.value.indexOf('/collections/') > -1) {
					if (isClearance()) {
						for (var product of products) {
							if (product.tags.length > 0) {
								if (product.tags.indexOf('Clearance') > -1 && product.tags.indexOf($(option).text().trim()) > -1) {
									if (availableOptions.indexOf($(option).text().trim()) === -1) {
										availableOptions.push($(option).text().trim());
									}
								}
							}
						}
					} else {
						for (var activeTag of $activeTags) {
							for (var product of products) {
								if (product.tags.length > 0) {
									// console.log(product.tags.indexOf(activeTag.innerText) > -1 && product.tags.indexOf(option.innerText) > -1);
									var tags = [];

									for (const tag of product.tags) {
										tags.push(tag.toLowerCase());
									}

									if (tags.indexOf($(activeTag).text().trim().toLowerCase()) > -1 && tags.indexOf($(option).text().trim().toLowerCase()) > -1) {
										if (availableOptions.indexOf($(option).text().trim()) === -1) {
											availableOptions.push($(option).text().trim());
										}
									}
								}
							}
						}
					}
				}
			}
		});

		callback(availableOptions);
	},
	RemoveOtherOptions: function(brandsToRemove) {
		var $selects = $('.utils-sortby:not(.utils-sortby--default) .form-field-select');
		
		$.each($selects, function(i, select) {
			var optionToShow = new Array;
			var options = $(select).children();

			for (var brand of brandsToRemove) {
				for (var option of options) {
					if (brand === $(option).text().trim()) {
						optionToShow.push(option);
					}
					if (option.value.indexOf('/collections/') > -1) {
						$(option).prop('disabled', true);
					}
				}
			}

			if (optionToShow.length > 0) {
				for (var option of optionToShow) {
					$(option).prop('disabled', false);
				}
			}

			$(select).find('option[position="0"]').prop('disabled', false);

			$.each(options, function(i, option) {
				if (option.disabled) {
					$(option).remove();
				}
			});
		});

		var $selectsModal = $('.utils-sortby--modal:not(.utils-sortby--modal--default) .utils-sortby--modal-list');
		$.each($selectsModal, function(i, select) {
			var optionToShow = new Array;
			var options = $(select).children();

			for (var brand of brandsToRemove) {
				for (var option of options) {
					if (brand === $(option).text().trim()) {
						optionToShow.push(option);
					}
				}
			}

			// console.log(optionToShow);

			if (optionToShow.length > 0) {
				$(select).html('');
				for (var option of optionToShow) {
					$(select).append(option);
				}
			}
		});

		var $selectsContainer = $('.utils-sortby:not(.utils-sortby--default)');
		$.each($selectsContainer, function(i, select) {
			$(select).removeClass('utils-sortby--loading');
		});
	}
}

$.fn.SetSelectecWidth = function() { 
	var $this = $(this);

	var _currentOption = $this.find(':selected').text();
	$this.append('<span class="hidden-current-option">' + _currentOption + '</span>');
	var $hiddenOption = $this.find('.hidden-current-option');
	var _selectedWidth = Math.floor($hiddenOption.width()) + 40;
	$hiddenOption.remove();

	$this.css({
		'width': _selectedWidth
	});
}